export const padToTwoDigits = number => String(number).padStart(2, '0')

export const timestampToDDMMYYYY = ({ timestamp }) => {
  if (!timestamp) return null

  const date = new Date(timestamp)

  const day = padToTwoDigits(date.getDate())
  const month = padToTwoDigits(date.getMonth() + 1)
  const year = date.getFullYear()
  const hours = padToTwoDigits(date.getHours())
  const minutes = padToTwoDigits(date.getMinutes())
  const seconds = padToTwoDigits(date.getSeconds())

  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
}

export const formatDate = ({ date }) => {
  if (!date) return null

  const day = padToTwoDigits(date.getDate())
  const month = padToTwoDigits(date.getMonth() + 1)
  const year = date.getFullYear()

  return `${year}-${month}-${day}`
}

export const getDDMMByExtraDate = ({ extraDate }) => {
  let date = new Date()
  if (extraDate && extraDate > 0) date.setDate(date.getDate() + extraDate)

  const day = padToTwoDigits(date.getDate())
  const month = padToTwoDigits(date.getMonth() + 1)

  return `${day}/${month}`
}

export const getDDMMYY = ({ date }) => {
  if (!date) return null

  const day = padToTwoDigits(date.getDate())
  const month = padToTwoDigits(date.getMonth() + 1)
  const year = date.getFullYear().toString().slice(2)

  return `${day}/${month}/${year}`
}

export const getDDMM = ({ date }) => {
  if (!date) return null

  const day = padToTwoDigits(date.getDate())
  const month = padToTwoDigits(date.getMonth() + 1)

  return `${day}/${month}`
}

export const getMMYY = ({ date }) => {
  if (!date) return null

  const month = padToTwoDigits(date.getMonth() + 1)
  const year = date.getFullYear().toString().slice(2)

  return `${month}/${year}`
}

export const timestampToDDMMHHMM = ({ timestamp }) => {
  if (!timestamp) return null

  const date = new Date(timestamp)

  const day = padToTwoDigits(date.getDate())
  const month = padToTwoDigits(date.getMonth() + 1)
  const hours = padToTwoDigits(date.getHours())
  const minutes = padToTwoDigits(date.getMinutes())

  return `${hours}h${minutes} de ${day}/${month} `
}

export const getHHmm = ({ hours, minutes }) => {
  return `${padToTwoDigits(hours)}h${padToTwoDigits(minutes)}`
}

export const getmm = ({ minutes }) => {
  return `${padToTwoDigits(minutes)}min`
}
